import { useRef } from 'react';
import BaseLogger, { BaseLoggerProps } from '../../../utilsTsx/components/system/logger/BaseLogger';
import systematic from '../../../config/systematic';
import { LoggerTypes } from '../../../bmCommonLibrary/bmDeclareTypes';

const Logger = (props: any) => {
    const ref = useRef<any>(undefined);

    /**
     * 扩展Props
     */
    let extendProps: BaseLoggerProps = {
        ...props,
        loggerServiceUrl: systematic.bmService,
        LoggerTypes,
        isLoggerClear: true,
        // isDisabledLoggerDateSelect: true,
        // isDisabledLoggerTypeSelect: true
    }
    return (
        <>
            <BaseLogger {...extendProps} />
        </>
    )
};

export default Logger;